enum ToastVariant {
    DANGER = 'danger',
    WARNING = 'warning',
    SUCCESS = 'success',
    INFO = 'info',
}

export default ToastVariant;
